import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=2f97a05a&scoped=true&"
import script from "./adminList.vue?vue&type=script&lang=js&"
export * from "./adminList.vue?vue&type=script&lang=js&"
import style0 from "./adminList.vue?vue&type=style&index=0&id=2f97a05a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97a05a",
  null
  
)

export default component.exports